/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { usePageContext } from "../../../../context/page/PageContext";
import { defaultImage } from "../../../../middlewares/libraries/imageKit/ImageKit";
import { _PAGE_SIZE_ } from "../../../../middlewares/other/tools";
import { Pagination } from "../../component/Pagination";
import { Search } from "../../component/searchUtils";
import {
  FiCalendar,
  FiTag,
  FiPlus,
  FiMinus,
  FiCheck,
  FiX,
  FiInfo,
} from "react-icons/fi";

const EventsList = ({ setPages, pages }) => {
  const { events, fetchEvents, eventsCount } = usePageContext();
  const [page, setPage] = useState(1);
  const [eventsList, setEventsList] = useState(null);
  const [pageSize, setPageSize] = useState(_PAGE_SIZE_);
  const [modal, setModal] = useState({ open: false, action: null, payload: null });

  useEffect(() => {
    if (!events) fetchEvents(page, pageSize);
    else setEventsList(events);
  }, [events]);

  const SearchList = (e) => {
    const key = e.target.value.toString().toLowerCase();
    if (!events) return;
    const arr = events.filter((ev) => String(ev.title).toLowerCase().includes(key));
    setEventsList(key ? arr : events);
  };

  const slugify = (t) => String(t || "").toLowerCase().replace(/\s/g, "_");
  const isAdded = (s) => pages?.some((p) => p.slug === s);

  const onAdd = (ev) =>
    setModal({ open: true, action: "add", payload: ev });
  const onRemove = (ev) =>
    setModal({ open: true, action: "remove", payload: ev });

  const confirm = () => {
    const ev = modal.payload;
    if (!ev) return setModal({ open: false, action: null, payload: null });
    const s = slugify(ev.title);
    if (modal.action === "add") {
      setPages([
        ...pages,
        {
          title: ev.title,
          hashtag: `event/${ev.event_id}`,
          thumbnail: ev.thumbnail ? ev.thumbnail : defaultImage,
          image_cdn_id: ev.thumbnailId ? ev.thumbnailId : "...",
          description: ev.description,
          slug: s || ".",
          category: ev.category,
          status: 1,
        },
      ]);
    }
    if (modal.action === "remove") {
      setPages(pages.filter((val) => val.slug !== s));
    }
    setModal({ open: false, action: null, payload: null });
  };

  return (
    <div className="mb-5 w-full py-2">
      <div className="rounded-2xl border border-gray-200 bg-white shadow-sm">
        <div className="flex flex-col gap-3 px-3 py-3 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-center gap-2">
            <span className="grid h-9 w-9 place-items-center rounded-lg bg-gray-900 text-white">
              <FiCalendar className="h-5 w-5" />
            </span>
            <div>
              <div className="text-sm font-semibold text-gray-900">Events</div>
              <div className="mt-1 flex flex-wrap items-center gap-2 text-[11px]">
                <span className="inline-flex items-center gap-1 rounded-full border border-gray-200 bg-gray-100 px-2.5 py-1 text-gray-700">
                  <FiTag className="h-3.5 w-3.5" />
                  {eventsList ? eventsList.length.toLocaleString() : 0} results
                </span>
                <span className="inline-flex items-center gap-1 rounded-full border border-emerald-200 bg-emerald-50 px-2.5 py-1 text-emerald-700">
                  <FiInfo className="h-3.5 w-3.5" />
                  Click Add to include in page
                </span>
              </div>
            </div>
          </div>
          <div className="w-full sm:w-80">
            <Search
              props={{
                title: "Search events…",
                onChange: (e) => SearchList(e),
              }}
            />
          </div>
        </div>

        <div className="relative max-h-[60vh] overflow-auto rounded-b-2xl">
          <table className="min-w-full table-fixed text-sm">
            <thead className="sticky top-0 z-10 bg-white/90 backdrop-blur">
              <tr className="text-left text-xs uppercase tracking-wide text-gray-500">
                <th className="w-[55%] px-3 py-3 font-semibold">
                  <span className="inline-flex items-center gap-2">
                    <FiTag className="h-4 w-4" />
                    Title
                  </span>
                </th>
                {/* <th className="w-[25%] px-3 py-3 font-semibold">
                  <span className="inline-flex items-center gap-2">
                    <FiClock className="h-4 w-4" />
                    Start Date
                  </span>
                </th> */}
                <th className="px-3 py-3 text-center font-semibold">Action</th>
              </tr>
            </thead>
            <tbody>
              {events && eventsList ? (
                eventsList.map((ev) => {
                  const s = slugify(ev.title);
                  const added = isAdded(s);
                  return (
                    <tr key={ev.event_id} className="border-t border-gray-100 hover:bg-gray-50/70">
                      <td className="px-3 py-3 align-middle">
                        <div className="flex items-center gap-3">
                          <img
                            src={ev.thumbnail || defaultImage}
                            alt=""
                            className="h-9 w-9 rounded-lg object-cover ring-1 ring-gray-200"
                          />
                          <div className="min-w-0">
                            <div className="truncate font-semibold text-gray-900">
                              {ev.title}
                            </div>
                            <div className="truncate text-[11px] text-gray-500">
                              #{ev.event_id}
                            </div>
                          </div>
                        </div>
                      </td>
                      {/* <td className="px-3 py-3 align-middle">
                        <span className="inline-flex items-center gap-2 rounded-lg bg-gray-100 px-2.5 py-1 text-[11px] font-semibold text-gray-700 ring-1 ring-gray-200">
                          <FiClock className="h-3.5 w-3.5" />
                          {ev.start_date}
                        </span>
                      </td> */}
                      <td className="px-3 py-3 align-middle">
                        <div className="flex items-center justify-center">
                          {added ? (
                            <button
                              type="button"
                              onClick={() => onRemove(ev)}
                              className="inline-flex items-center gap-2 rounded-lg bg-orange-600 px-3 py-2 text-xs font-semibold text-white shadow hover:bg-orange-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-orange-500"
                            >
                              <FiMinus className="h-4 w-4" />
                              Remove
                            </button>
                          ) : (
                            <button
                              type="button"
                              onClick={() => onAdd(ev)}
                              className="inline-flex items-center gap-2 rounded-lg bg-emerald-600 px-3 py-2 text-xs font-semibold text-white shadow hover:bg-emerald-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500"
                            >
                              <FiPlus className="h-4 w-4" />
                              Add
                            </button>
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td className="px-3 py-6 text-center text-gray-500" colSpan={3}>
                    Loading…
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div className="border-t border-gray-100 px-3 py-3">
          <Pagination
            page={page}
            setPage={setPage}
            pageSize={pageSize}
            setPageSize={setPageSize}
            total_items={eventsCount}
            callbackFunction={(_p, _s) => fetchEvents(_p, _s)}
          />
        </div>
      </div>

      <ConfirmModal
        open={modal.open}
        title={modal.action === "add" ? "Add this event to the page?" : "Remove this event from the page?"}
        description={
          modal.payload
            ? modal.action === "add"
              ? `“${modal.payload.title}” will be included in your page.`
              : `“${modal.payload.title}” will be removed from your page.`
            : ""
        }
        onCancel={() => setModal({ open: false, action: null, payload: null })}
        onConfirm={confirm}
        confirmText={modal.action === "add" ? "Add" : "Remove"}
        tone={modal.action === "remove" ? "danger" : "primary"}
      />
    </div>
  );
};

export default EventsList;

const ConfirmModal = ({
  open,
  title,
  description,
  onCancel,
  onConfirm,
  confirmText = "Proceed",
  tone = "primary",
}) => {
  if (!open) return null;
  return createPortal(
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="confirm-title"
      aria-describedby="confirm-desc"
      className="fixed inset-0 z-[2147483647] isolate flex items-center justify-center p-4"
    >
      <div className="absolute inset-0 bg-black/70 backdrop-blur-[2px]" onClick={onCancel} />
      <div className="relative w-full max-w-md rounded-2xl border border-gray-200 bg-white/95 shadow-2xl ring-1 ring-black/5 supports-[backdrop-filter]:bg-white/85">
        <div className="absolute inset-x-0 top-0 h-1 rounded-t-2xl bg-gradient-to-r from-emerald-500 via-amber-500 to-fuchsia-500" />
        <div className="relative px-5 pt-5">
          <div className="flex items-start gap-3">
            <span
              className={[
                "grid h-9 w-9 place-items-center rounded-lg",
                tone === "danger" ? "bg-red-100 text-red-700" : "bg-emerald-100 text-emerald-700",
              ].join(" ")}
            >
              {tone === "danger" ? <FiMinus className="h-5 w-5" /> : <FiPlus className="h-5 w-5" />}
            </span>
            <div>
              <h3 id="confirm-title" className="text-base font-semibold text-gray-900">
                {title}
              </h3>
              {description ? (
                <p id="confirm-desc" className="mt-1 text-sm text-gray-600">{description}</p>
              ) : null}
            </div>
          </div>
        </div>
        <div className="px-5 pb-5 pt-4 flex items-center justify-end gap-2">
          <button
            type="button"
            onClick={onCancel}
            className="inline-flex items-center gap-2 rounded-lg border border-gray-200 bg-white px-3 py-2 text-xs font-semibold text-gray-700 hover:bg-gray-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500"
          >
            <FiX className="h-4 w-4" />
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className={[
              "inline-flex items-center gap-2 rounded-lg px-3 py-2 text-xs font-semibold text-white shadow focus:outline-none focus-visible:ring-2",
              tone === "danger"
                ? "bg-orange-600 hover:bg-orange-700 focus-visible:ring-orange-500"
                : "bg-emerald-600 hover:bg-emerald-700 focus-visible:ring-emerald-500",
            ].join(" ")}
          >
            <FiCheck className="h-4 w-4" />
            {confirmText}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};
